const ticketNo = ticketNo => {
	var tcs = ticketNo.split("|");
	let ret = true;
	for(var i=0; i< tcs.length;i++){
		let tn = tcs[i];
		if(!tn) ret=true;
		if(tn.length > 30) ret = false;
		ret = /^[A-z]{1,10}[0-9]{1,20}$/.test(tn);

		if(!ret) return ret;
	}
	return ret;
}

export default ticketNo
